
import React from 'react';
//const ApiURl = "http://localhost/Txn_Main%20react%20(1)/Txn_Main%20react/Backend/";
 const ApiURl = "https://avp.algo2botsinfotech.com/Backend";
 






 

    export default   ApiURl ;